import React from 'react';
import { useTheme } from '../ThemeContext';
import ModalLayer from './ModalLayer';

export default function ConfirmDialog({
  open,
  title,
  message,
  children,
  confirmLabel = 'Continue',
  cancelLabel = 'Cancel',
  onConfirm,
  onCancel,
  busy = false,
  confirmDisabled = false,
}) {
  const { colors } = useTheme();
  if (!open) return null;

  return (
    <ModalLayer
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1200,
        padding: '1rem',
      }}
    >
      <div
        className="app-modal-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-dialog-title"
        style={{
          background: colors.surface,
          color: colors.text,
          borderRadius: '1rem',
          padding: '1.5rem',
          maxWidth: '480px',
          width: '100%',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
        }}
      >
        <h2 id="confirm-dialog-title" style={{ margin: '0 0 0.75rem', fontSize: '1.25rem' }}>
          {title}
        </h2>
        {children || (
          <p style={{ margin: '0 0 1.25rem', whiteSpace: 'pre-wrap', lineHeight: 1.5 }}>{message}</p>
        )}
        <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end', marginTop: children ? '1.25rem' : 0 }}>
          <button type="button" onClick={onCancel} disabled={busy}>
            {cancelLabel}
          </button>
          <button type="button" onClick={onConfirm} disabled={busy || confirmDisabled}>
            {busy ? 'Working...' : confirmLabel}
          </button>
        </div>
      </div>
    </ModalLayer>
  );
}
